export function isToday(date) {
  const now = new Date();

  return (
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate()
  );
}

export function getNextWeek() {
  const now = new Date();
  const nextWeek = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 7
  );
  nextWeek.setHours(18, 0, 0);
  return nextWeek;
}

export function getNextYear() {
  const now = new Date();

  const nextYear = new Date(
    now.getFullYear() + 1,
    now.getMonth(),
    now.getDate()
  );
  nextYear.setHours(18, 0, 0);
  return nextYear;
}

export function getBeginningOfToday() {
  const today = new Date();
  today.setHours(0, 0, 0);
  return today;
}

export function getEndOfToday() {
  const today = new Date();
  today.setHours(23, 59, 0);
  return today;
}
